module.exports = __webpack_public_path__ + "static/media/IMG_5540.2dadf27e.jpg";